import { AuxAccordion, AuxAccordionExpansionPanel, AuxSecondaryNavigationOptionGroup } from "@blk/aladdin-react-components-es";
import { AuxAccordionExpansionPanelTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPanelExpanded } from "store/left-pane";
const InsAccordionComponent = (props) => {
    const dispatch = useDispatch(), { badge, paneId, onCreateNavigationOption, panels } = props, expandedPanels = useSelector((state) => state.leftPane[paneId]?.expandedPanels ?? {}, isEqual);
    const isPanelExpanded = (id) => (id in expandedPanels ? expandedPanels[id] : true);
    const handlePanelClicked = (id, event) => {
        if (event.detail?.srcEvent?.target?.id === "AuxButtonEllipsis" ||
            event.detail?.srcEvent?.target?.slot === "target") {
            event.stopPropagation();
        }
        else {
            const expanded = isPanelExpanded(id);
            dispatch(setPanelExpanded({
                expanded: !expanded,
                leftPaneId: paneId,
                panelId: id
            }));
        }
    };
    return React.createElement(AuxAccordion, { isBorderLess: true, isFreeMode: true, size: AuxAccordionExpansionPanelTypeEnum.STANDARD }, panels.map((panel) => React.createElement(AuxAccordionExpansionPanel, { key: panel.id, header: panel.name, isExpanded: isPanelExpanded(panel.id), onPanelClicked: (e) => handlePanelClicked(panel.id, e) },
        React.createElement("div", { slot: "content" },
            React.createElement(AuxSecondaryNavigationOptionGroup, { hasBottomDivider: false }, Object.entries(panel.sections)
                .map(([section, name]) => onCreateNavigationOption(name, panel.id, section)))),
        badge && React.createElement("div", { slot: "badge" }, badge(Number(panel.id))))));
};
InsAccordionComponent.displayName = "InsAccordion";
export const InsAccordion = memo(InsAccordionComponent, isEqual);
InsAccordion.displayName = "InsAccordion";
